export default "__VITE_ASSET__f09ed42d__"